<template>
  <main role="main" class="col content-spacing">
    <loading-list v-if="viewData.loading"></loading-list>
    <b-container v-else>
      <b-row>
        <b-col>
          <div
            class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom"
          >
            <h1 class="h2">
              {{ viewData.id ? `Editar ${state.question}` : 'Novo Cupom' }}
            </h1>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-breadcrumb
            :items="[
              {
                text: 'Lista de Cupons',
                href: '#/coupons',
              },
              {
                text: 'Cadastro de Cupons',
                href: '#',
                active: true,
              },
            ]"
          ></b-breadcrumb>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
            <b-form>
              <error-container v-bind:errors="viewData.errors || []" />

              <b-form-group label="Nome/Identificador">
                <b-form-input
                  v-model="state.name"
                  required
                  placeholder="Informe o nome/Identificador"
                  :state="isOk('name')"
                ></b-form-input>
                <b-form-invalid-feedback>{{
                  getError('name')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group
                id="input-group-2"
                label="Descrição"
                label-for="input-2"
              >
                <b-form-textarea
                  v-model="state.description"
                  placeholder="Informe a descrição"
                  rows="3"
                  max-rows="6"
                  :state="isOk('description')"
                ></b-form-textarea>
                <b-form-invalid-feedback>{{
                  getError('description')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group
                id="input-group-1"
                label="Data Início"
                label-for="input-1"
              >
                <b-form-datepicker
                  :state="isOk('start')"
                  id="example-datepicker-beg"
                  placeholder="Selecione uma data"
                  v-model="state.start"
                  class="mb-2"
                ></b-form-datepicker>
                <b-form-invalid-feedback>{{
                  getError('start')
                }}</b-form-invalid-feedback>

                <b-form-invalid-feedback>{{
                  getError('start')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group
                id="input-group-2"
                label="Data Fim"
                label-for="input-1"
              >
                <b-form-datepicker
                  :state="isOk('end')"
                  id="example-datepicker-end"
                  placeholder="Selecione uma data"
                  v-model="state.end"
                  class="mb-2"
                ></b-form-datepicker>
                <b-form-invalid-feedback>{{
                  getError('end')
                }}</b-form-invalid-feedback>

                <b-form-invalid-feedback>{{
                  getError('end')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group
                id="input-group-3"
                label="Perfil"
                label-for="input-group-3"
              >
                <select v-model="state.profile" class="form-control">
                  <option disabled value>Selecione o perfil</option>
                  <option value="consumer">Consumidor</option>
                  <option value="trader">Comercializador</option>
                  <option value="investor">Investidor</option>
                </select>
                <div :class="{ 'is-invalid': !isOk('profile') }"></div>
                <b-form-invalid-feedback v-if="isOk('profile') === false">{{
                  getError('profile')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group
                id="input-group-3"
                label="Tipo"
                label-for="input-group-3"
                v-if="state.profile"
              >
                <select v-model="state.type" class="form-control">
                  <option disabled value>Selecione o tipo</option>
                  <option v-for="(type, index) in typeOptions" :key="`${index}-${type.value}`" :value="type.value">
                    {{ type.text }}
                  </option>
                </select>
                <div :class="{ 'is-invalid': !isOk('type') }"></div>
                <b-form-invalid-feedback v-if="isOk('type') === false">{{
                  getError('type')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group
                id="input-group-3"
                label="Status"
                label-for="input-group-3"
              >
                <select v-model="state.status" class="form-control">
                  <option disabled value>Selecione o status</option>
                  <option value="ACTIVE">Ativo</option>
                  <option value="INACTIVE">Inativo</option>
                </select>
                <div :class="{ 'is-invalid': !isOk('status') }"></div>
                <b-form-invalid-feedback v-if="isOk('status') === false">{{
                  getError('status')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group
                id="input-group-2"
                label="Limite"
                label-for="input-1"
              >
                <b-form-input
                  class="text-right"
                  v-model="state.limit"
                  placeholder="Informe o limite de usos do cupom"
                  :state="isOk('value')"
                  @change="calc()"
                  @keypress="isNumber($event)"
                ></b-form-input>
                <b-form-invalid-feedback>{{
                  getError('limit')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <submit-button
                v-bind:action="() => save()"
                v-bind:label="'Salvar'"
              ></submit-button>
            </b-form>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </main>
</template>

<script>
import helpers from '../../vue/helpers';
import { Api } from '../../vue/api';

const API = new Api();

export default {
  name: 'coupon-edit',
  data: function() {
    return {
      state: {
        name: '',
        description: '',
        start: null,
        end: null,
        type: '',
        profile: '',
        status: 'ACTIVE',
        limit: 0,
        typeOptions: []
      },
      viewData: {
        id: 0,
        loading: false,
        errors: [],
      },
    };
  },
  computed: {
    typeOptions() {
      const types = {
        'trader': [
          { value: 'NA', text: 'Não se aplica' },
        ],
        'consumer': [
          { value: 'CONSUMER_1', text: 'Consumidor 1%' },
          { value: 'CONSUMER_2', text: 'Consumidor 2%' },
          { value: 'CONSUMER_3', text: 'Consumidor 3%' },
          { value: 'CONSUMER_4', text: 'Consumidor 4%' },
          { value: 'CONSUMER_5', text: 'Consumidor 5%' },
        ],
        'investor': [
          { value: 'LAST_X2', text: 'Última x 2' },
          { value: 'LAST_X3', text: 'Última x 3' },
          { value: 'LAST_X4', text: 'Última x 4' },
          { value: 'LAST_X5', text: 'Última x 5' },
          { value: 'LAST_X6', text: 'Última x 6' },
        ],
      }
      return types[this.state.profile]
    },
  },
  beforeMount: async function() {
    const _id = this.$route.params ? this.$route.params.id : 0;

    if (_id) {
      this.viewData.id = _id;

      try {
        this.viewData.loading = true;

        const result = await API.post('/execute', {
          path: '/coupon/' + _id,
          method: 'get',
        });

        this.state = { ...result.model };
        this.viewData.loading = false;
      } catch (ex) {
        this.$toast.error(helpers.getFirstError(ex));
      }
    }
  },
  methods: {
    getError(property) {
      return helpers.getError(this.viewData.errors, property);
    },
    isOk(property) {
      let hasError = helpers.hasError(this.viewData.errors, property);
      if (hasError) {
        return false;
      }
    },
    updateUrl(url) {
      this.state.url = url;
    },
    setLoadingPhoto(loading) {
      this.viewData.loadingPhoto = loading;
    },
    isNumber($event) {
      return helpers.isNumber($event);
    },
    async save() {
      try {
        const result = await API.post('/execute', {
          path: this.viewData.id ? `/coupon/${this.viewData.id}` : '/coupon/',
          method: this.viewData.id ? 'put' : 'post',
          data: this.state,
        });

        this.$toast.success('Cupom incluído com sucesso');

        this.$router.push('/coupons');
      } catch (ex) {
        this.viewData.errors = helpers.getErrors(ex);
      }
    },
  },
  components: {
    'image-upload': require('../image-upload.vue').default,
  },
};
</script>
